import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { TaskManagementTaskDetail } from '../../data-contract/task-management';

/**
 * Sections a page adds below a work task's fields, such as Home's automations the person selected
 * for the task. Tiles opened outside such a page show none.
 */
export type WorkTaskTileSections = (task: TaskManagementTaskDetail) => ReactNode;

const WorkTaskTileSectionsContext = createContext<WorkTaskTileSections | null>(null);

export const WorkTaskTileSectionsProvider = WorkTaskTileSectionsContext.Provider;

export const useWorkTaskTileSections = (): WorkTaskTileSections | null => useContext(WorkTaskTileSectionsContext);

/** Whether work task tiles leave out a task's parents and children, as on Home where a person sees their own tasks. */
const WorkTaskTileHidesHierarchyContext = createContext(false);

export const WorkTaskTileHidesHierarchyProvider = WorkTaskTileHidesHierarchyContext.Provider;

export const useWorkTaskTileHidesHierarchy = (): boolean => useContext(WorkTaskTileHidesHierarchyContext);
